import React from "react";
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    FormControlLabel,
} from "@mui/material";
import { LocationIcon } from "../../../utils/locationIcons";

export default function SectionStandorte({
                                             form,
                                             setForm,
                                             locations,
                                             locationsLoading,
                                             locationsError,
                                         }) {
    const ids = new Set((form.location_ids || []).map(Number));

    const sorted = React.useMemo(() => {
        return [...(locations || [])]
            .filter((item) => item.is_active !== false)
            .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0) || String(a.label_de || "").localeCompare(String(b.label_de || ""), "de"));
    }, [locations]);

    const toggle = (id) => {
        setForm((f) => {
            const current = new Set((f.location_ids || []).map(Number));
            if (current.has(id)) current.delete(id);
            else current.add(id);
            return { ...f, location_ids: [...current] };
        });
    };

    if (locationsLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={22} />
            </Box>
        );
    }

    if (locationsError) return <Alert severity="error">{locationsError}</Alert>;

    if (!sorted.length) {
        return <Alert severity="info">Keine Standorte vorhanden. Lege zuerst Standorte / Umgebung in der Verwaltung an.</Alert>;
    }

    return (
        <Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))" },
                    gap: 1,
                }}
            >
                {sorted.map((location) => (
                    <FormControlLabel
                        key={location.id}
                        control={
                            <Checkbox
                                size="small"
                                checked={ids.has(Number(location.id))}
                                onChange={() => toggle(Number(location.id))}
                            />
                        }
                        label={
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                                <LocationIcon iconName={location.icon_name} />
                                <span>{location.label_de || location.name}</span>
                            </Box>
                        }
                    />
                ))}
            </Box>
        </Box>
    );
}
